import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
    <p>
      <br/>
      <strong>Description</strong>
    </p>
    <p>
      This action triggers the bottom 5 stowers with the highest stowed package opportunity missed. Where Stowed Package
      Opportunity Missed is equal to (Expected Rate - Actual Rate) * Hours. These associates have a minimum of 10 hours in
      path
      from prior week.
    </p>
    <p><strong>Impact</strong></p>
    <p>
      Sort to Container is a direct representation of production output quantifying the number of completed packages ready
      for a singular route. By having visibility on the bottom performers, this will have a direct impact on the number
      engagements that are conducted on a daily basis, therefore facilitating increased stow output. The action will direct
      the associate's Area Manager to immediately perform an Apollo audit for best practices effecting PPH and direct stow
      rates.
    </p>
    <p><strong>Resolution Steps</strong></p>
    <p>
      1) Complete the <span className="wikiinternallink"><a
      href="https://apollo-audit.corp.amazon.com/audits/new?audit_type_id=2850">AMZL Stow Productivity Retrain in Apollo</a></span>.<br/>
      2) After completing the Retrain, please close the SCC Work Item.&nbsp;
    </p>
    <div className="wikimodel-emptyline"></div>
    <p><strong>Supplemental Links</strong></p>
    <p>
      1) <span className="wikiinternallink"><a href="https://apollo-audit.corp.amazon.com/audits/new?audit_type_id=2850">AMZL Stow Productivity Retrain in Apollo</a></span><br/>
      2)
      <span className="wikiinternallink">
            <a
              href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/3c512f1b-7832-4fe0-8cc9-69f72b8a31d4/sheets/3c512f1b-7832-4fe0-8cc9-69f72b8a31d4_e66b5c8d-8b84-4c83-8e05-4eb1c5a94c07?state=hashArgs%23&amp;isauthcode=true&amp;qs-signin-user-auth=false&amp;directory_alias=amzlbiaquicksight"
            >
                Learning Curve Dashboard
            </a>
        </span>
    </p>
  </div>`
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Stow_Productivity.jsx